import React, { memo } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import ChatHistoryList from './ChatHistoryList';
import './chat-workspace.css';

const ChatConversationSidebar = ({
  onNewChat,
  newChatLabel,
  children,
  chatHistoryProps,
  embedded = false,
}) => (
  <div className={['chat-conv-sidebar', embedded && 'chat-conv-sidebar--embedded'].filter(Boolean).join(' ')}>
    <div className="chat-conv-sidebar__header chat-conv-sidebar__header--compact">
      <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={onNewChat}
        className="chat-conv-sidebar__new-btn"
      >
        {newChatLabel}
      </Button>
    </div>
    <div className="chat-conv-sidebar__body">
      {children || <ChatHistoryList {...chatHistoryProps} />}
    </div>
  </div>
);

export default memo(ChatConversationSidebar);
